import React, { useState } from "react";
import { toast } from "sonner";
import { Share2, Copy, MessageCircle, Mail } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export function ShareInitiative({ url, title, initiativeId }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const canNative = typeof navigator !== "undefined" && !!navigator.share;

  const track = (event) => { if (initiativeId) api.post(`/initiatives/${initiativeId}/track`, { event }).catch(() => {}); };
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success(t("common.link_copied")); } catch { /* noop */ }
    track("copy_link"); setOpen(false);
  };
  const native = async () => { try { await navigator.share({ title, url }); } catch { /* noop */ } setOpen(false); };
  const wa = () => { window.open(`https://wa.me/?text=${encodeURIComponent(`${title} — ${url}`)}`, "_blank", "noopener"); track("whatsapp"); setOpen(false); };
  const email = () => {
    const subject = encodeURIComponent(t("initiatives.share_email_subject"));
    const body = encodeURIComponent(`${t("initiatives.share_email_intro")}: ${title}\n${url}`);
    const a = document.createElement("a");
    a.href = `mailto:?subject=${subject}&body=${body}`;
    a.click();
    track("email"); setOpen(false);
  };

  const Item = ({ icon: Icon, label, onClick, testId }) => (
    <button type="button" onClick={onClick} data-testid={testId}
      className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm text-slateink transition-colors hover:bg-terracotta-light">
      <Icon className="h-4 w-4 text-terracotta" /> {label}
    </button>
  );

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) track("share_open"); }}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="rounded-full" data-testid="share-initiative-btn">
          <Share2 className="mr-2 h-4 w-4" /> {t("common.share")}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56 p-1.5" data-testid="share-menu">
        {canNative && <Item icon={Share2} label={t("initiatives.share_native")} onClick={native} testId="share-native" />}
        <Item icon={Copy} label={t("common.copy_link")} onClick={copy} testId="share-copy-link" />
        <Item icon={MessageCircle} label={t("initiatives.share_whatsapp")} onClick={wa} testId="share-whatsapp" />
        <Item icon={Mail} label={t("initiatives.share_email")} onClick={email} testId="share-email" />
      </PopoverContent>
    </Popover>
  );
}
